import { render, staticRenderFns } from "./index.vue?vue&type=template&id=195fd3bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=195fd3bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195fd3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/jenkins/workspace/etower/etower-qa-tracking-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('195fd3bc')) {
      api.createRecord('195fd3bc', component.options)
    } else {
      api.reload('195fd3bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=195fd3bc&scoped=true", function () {
      api.rerender('195fd3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/spww/Header/components/LangSelect/index.vue"
export default component.exports